// import Image from "next/image";
// import Link from "next/link";
import React from "react";
import { SVG } from "../common/SVG";

interface SocialMediaIconProps {
  icon: string;
  link?: string;
  color?: string;
  type: "img" | "svg" | string;
  width?: number;
  height?: number;
}

const SocialMediaIcon = ({
  icon,
  link = "",
  color,
  type,
  width = 20,
  height = 20,
}: SocialMediaIconProps) => {
  return (
    <a href={link}>
      <div
        className={`flex h-[22px] w-[22px] items-center justify-center ${color}`}
      >
        {type == "img" && (
          <img
            src={icon}
            alt="logo"
            width={width}
            height={height}
            className="place-self-center self-center"
          />
        )}
        {type == "svg" && <SVG src={icon} width={width} height={height} />}
      </div>
    </a>
  );
};

export default SocialMediaIcon;
